import React from 'react';
import { Localizer } from 'services/Localizer';
import AppleIdExternalLoginSVG from 'shared/components/svg/AppleIdExternalLoginSVG';
import FacebookExternalLoginSVG from 'shared/components/svg/FacebookExternalLoginSVG';
import GoogleExternalLoginSVG from 'shared/components/svg/GoogleExternalLoginSVG';

export interface ExternalLoginsProps {
	externalLoginProviders?: ExternalLoginProvider[];
}

/**
 * The list of currently available external login providers
 */
export enum ExternalLoginProviders {
	Google = 'Google',
	Facebook = 'Facebook',
	AppleId = 'Apple',
}

/**
 * Information about a single external login provider, usually provided by the server
 */
export interface ExternalLoginProvider {
	Name: string;
	DisplayName: string;
}

/**
 * Renders the provided external login provider "log in" buttons, for providers such as Google, Facebook, AppleId, etc
 */
export default function ExternalLogins(props: ExternalLoginsProps) {
	if (!props.externalLoginProviders || props.externalLoginProviders.length === 0) {
		console.warn('No external login providers provided for rendering!');
		return null;
	}

	function getExternalLoginIcon(providerName: string) {
		switch (providerName) {
			case ExternalLoginProviders.Google:
				return <GoogleExternalLoginSVG />;
			case ExternalLoginProviders.Facebook:
				return <FacebookExternalLoginSVG />;
			case ExternalLoginProviders.AppleId:
				return <AppleIdExternalLoginSVG />;
			default:
				return null;
		}
	}

	// We want this to actually redirect the user, so we use a native form with a native POST request to the server,
	// which will redirect us to the appropriate place
	return (
		<form id="external-login-form" action="/my-account/external-login" method="post">
			<div id="socialLoginList">
				{props.externalLoginProviders.map((provider, index) => (
					<div key={index}>
						<button
							id={`external-login-button-${provider.Name}`}
							data-testid={`external-login-button-${provider.Name}`}
							type="submit"
							className={`roc-vendor-btn roc-vendor-btn--${provider.Name}`}
							name="provider"
							value={provider.Name}
							title={Localizer('LoginWithExternalAccountButtonTitle', provider.DisplayName)}
						>
							<span className="roc-vendor-btn__icon-wrapper">{getExternalLoginIcon(provider.Name)}</span>
							<span className="roc-vendor-btn__text-wrapper">
								{Localizer('LoginWithExternalAccountButtonText', provider.DisplayName)}
							</span>
						</button>
					</div>
				))}
			</div>
		</form>
	);
}
